<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";
    import {decode, encode} from "../../../helpers";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    const user = store('credential', 'getAuth');

    export let calc;
    export let options;


    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {

            let fetched = await network.fetch_tovar(item.idTovar);
            if (fetched.ind3.length > 30) {
                let json = JSON.parse(decode(fetched.ind3));

                width.set(json.width);
                height.set(json.height);
                uplot = json.uplot;
                ind2.set(json.ind2);
                ind3 = json.ind3;
                porog = json.porog;
                webtype.set(json.webtype);
                type = json.type;
                vidShtor = json.vidShtor;
                cvetShtor = json.cvetShtor;
                falsrama= json.falsrama;
                change();


            } else {
                let title = item.title.split(' ', 3);

                width.set(title[1].split('x')[0]);
                height.set(title[1].split('x')[1]);
                ind2.set(title[2]);
                ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
                uplot = uplotnenie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
                porog = item.title.toLowerCase().includes('низкий') ? 'Низкий' : 'Рамный';
                webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));

                type = [...types]
                    .sort((a, b) => b.length - a.length)
                    .find((el) => item.title.toLowerCase().includes(el.toLowerCase())) ?? type;


                count.set(+item.quantity);
                comment.set(item.comment);
                fetchData = await fetch($ind2);
                change();
            }
        }
    };

    const otkrivanie = [
        'Створка влево',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка вправо',
        'Створка от краев к середине'
    ];

    const uplotnenie = [
        'Без уплотнения',
        'Щеточный',
        'Магнитный'
    ];

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    };

    const webtypes = options.webtype || [
        'Обычная',
    ];

    const types = [ 'Ткань', 'Сетка/Ткань'];


    const SHTORKA_TYPES = [
        {type: 'ПЛИССЕ DARKOUT 90%', keyword: ['ПЛИССЕ DARKOUT 90%'.toLowerCase()]}, // --
        {type: 'ПЛИССЕ полупрозрачная 60%', keyword: ['ПЛИССЕ полупрозрачная 60%'.toLowerCase()]}, // --
        {type: 'СОТА BLACKOUT 16мм', keyword: ['СОТА BLACKOUT 16мм'.toLowerCase()]}, // --
        {type: 'СОТА BLACKOUT 20мм', keyword: ['СОТА BLACKOUT 20мм'.toLowerCase()]}, // --
        {type: 'СОТА полупрозрачная 16 мм', keyword: ['СОТА полупрозрачная 16 мм'.toLowerCase()]}, // --
        {type: 'ПЛИССЕ 20мм (влагостойкая)', keyword: ['ПЛИССЕ 20мм (влагостойкая)'.toLowerCase()]}, // --

    ];

    const canon = (value) => String(value || '').trim().toLowerCase().replace(/ё/g, 'е');

    const colorOf = (value) => {
        const matched = String(value || '').match(/\(([^)]+)\)\s*$/);
        return canon(matched ? matched[1] : value);
    };

    // Совпадает и старое значение «Белый», и запись из базы «15.60.01 (Белый)».
    const sameColor = (stored, selected) => {
        const left = canon(stored);
        const right = canon(selected);
        return left === right || colorOf(stored) === colorOf(selected);
    };

    function availableShtorTypes(result) {
        if (!result) return [];

        const names = result.filter(i => i.flag === '1').map(i => i.name.toLowerCase());

        return SHTORKA_TYPES.filter(({keyword}) =>
            keyword.some(kw => names.some(n => n.includes(kw)))
        );
    }

    // Список цветов шторки в зависимости от вида
    function shtorkaColors(type, result) {
        if (!result) return [];
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        const l = [...new Set(
            result
                .filter(i => entry.keyword.some(kw => i.name.toLowerCase().includes(kw)) && i.flag === '1')
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )]

        //  ind4 = l[0];

        return l;
    }

    function shtorkaKeywordForCalc(type, colorValue, result) {
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        // Если у типа один keyword
        if (entry.keyword.length === 1) return entry.keyword;

        // Если несколько
        const matched = entry.keyword.filter(kw =>
            result.some(i =>
                i.name.toLowerCase().includes(kw) &&
                sameColor(i.ind2, colorValue)
            )
        );

        return matched.length ? matched : entry.keyword;
    }

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Перегородка с тканью', '', color);
        let options = await network.fetch_ind('Перегородка с тканью');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '2000'),
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        uplot = 'Щеточный', // уплотнитель
        porog = 'Рамный', // уплотнитель
        webtype = parameter('webtype', 'Обычная'), // тип сетки плиссе
        type = 'Ткань',
        comment = parameter('comment', ''),
        count = parameter('count', 1),
        vidShtor = 'ПЛИССЕ DARKOUT 90%',
        cvetShtor = 'Антрацит',
        falsrama = 'Нет' ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        const colors = shtorkaColors(vidShtor, data.result);
        if (colors.length && colors.indexOf(cvetShtor) === -1) {
            const found = colors.find((item) => sameColor(item, cvetShtor));
            if (found) {
                cvetShtor = found;
            }
        }

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let webName;
        switch (type) {
            case 'Сетка':
                webName = $webtype;
                break;
            case 'Ткань':
                webName = vidShtor + ' ' + cvetShtor;
                break;
            case 'Сетка/Ткань':
                webName = $webtype + ' и ' + vidShtor + ' ' + cvetShtor;
                break;
            default:
                webName = '';
        }

        let result = {
            type: 'п16Np',
            name: 'п16Np',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', type, ' ', webName, ' ', uplot, ' ', porog , ' порог', (falsrama=="Да"? ' с фальшрамой': '')
            ].join(''),
            title: [
                'Перегородки с тканью', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', type, ' ', webName, ' ', uplot, ' ', porog , ' порог', (falsrama=="Да"? ' с фальшрамой': '')
            ].join(''),
            params: {
                ind1: uplot + ' '+  porog + ' порог',
                ind2: $ind2,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    uplot,
                    ind2: $ind2,
                    ind3,
                    porog,
                    type,
                    webtype: $webtype,
                    vidShtor,
                    cvetShtor,
                    falsrama
                })),
                ind4: $width,
                ind5: $height,
            },


            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 169
        };


        const nt = data.result.find((el) => el.name.includes('аценка на ткань'))
        let nacenkaTkanRozn = 1
        let nacenkaTkanOpt = 1
        let nacenkaTkanSebest = 1
        if (nt) {
            nacenkaTkanRozn = +nt.price || 1
            nacenkaTkanOpt = +nt.opt_price || 1
            nacenkaTkanSebest = +nt.sebestomost || 1
        }



        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;




            // системе СЛИМ при расчете  объема сетки (полотна) в кол-ве волн нужно увеличить на 10% (с округлением в большую сторону)

            if (name.includes('сетка мс плиссе') && type != 'Ткань') {

                if (!$webtype) return;

                switch (true) {
                    case $webtype === 'Обычная' && (name.includes('антипыль') || name.includes('антимошка') || name.includes('антикошка')):
                        return;

                    case $webtype === 'Антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype === 'Антимошка' && !name.includes('антимошка'):
                        return;

                    case $webtype === 'Антикошка' && !name.includes('антикошка'):
                        return;
                }

                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }

                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        wave = Math.ceil(w * 55 / 1100);
                        if (porog == 'Рамный') {
                            kolvo = (((h - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        } else {
                            kolvo = (((h - 35 + 17) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        }
                        break;
                    case 'Створка от краев к середине':
                        wave = Math.ceil(w * 55 / 1100);
                        if (porog == 'Рамный') {
                            kolvo = (((h - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        } else {
                            kolvo = (((h - 35 + 17) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        }
                        break;

                    default:  //Створка вертикал
                        wave = Math.ceil(h * 55 / 1100);
                        kolvo = (((w - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(3);
                        break;
                }
            }
            if (type != 'Сетка') {
                if (vidShtor === 'Полупрозрачная' && name.includes('плиссированная шторка из полиэстера')) {
                    if (sameColor(item.ind2, cvetShtor)) {
                        kolvo = ((w - 2) * h / 2.2 * 0.028 / 10000).toFixed(3);
                    }
                } else {
                    const shtorKeywords = shtorkaKeywordForCalc(vidShtor, cvetShtor, data.result);

                    if (shtorKeywords.some(kw => name.includes(kw)) && sameColor(item.ind2, cvetShtor)) {
                        kolvo = ((w / 1000) * h / 7.7 * 10 / 1000).toFixed(3);
                    }
                }
            }

            if (name.includes('профиль рамный п16 new')) {
                switch (porog) {
                    case 'Низкий': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                            case 'Створки от краев к середине горизонтальные':
                                kolvo = (((w - 30) + (h - 47) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Рамный': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                            case 'Створки от краев к середине горизонтальные':
                                kolvo = (((w - 30) * 2 + (h - 54) * 2) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = (((h - 30) * 2 + (w - 54) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('профиль створочный п16 new')) {
                switch (porog) {
                    case 'Низкий': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 49) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 49) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створки от краев к середине горизонтальные':
                                kolvo = ((w - 61) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Рамный': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 61) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створки от краев к середине горизонтальные':
                                kolvo = ((w - 61) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('порог мс плиссе 16мм')) {
                if (porog === 'Низкий') {
                    kolvo = ((w - 24) / 1000).toFixed(3);
                }
            }

            if (name.includes('нить мс плиссе')) {
                let  k2,k3;

                let l =h;
                if (ind3.includes('горизонтальные') || ind3.includes('верх')){
                    l =w;
                }

                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    k2 = 2;
                } else {
                    k2 = 1;
                }
                k3 =(Math.ceil(((l -40)/ 320 +  1)) * k2);
                kolvo = ((w + h + 200) / 1000   * k2 * k3).toFixed(3);

            }
            if (
                name.includes('нитедержатель') ||
                name.includes('нитенаправитель') ||
                name.includes('люверс') ||
                name.includes('саморез для п16')
            ) {
                let k;

                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    k = 2;
                } else {
                    k = 1;
                }

                let l =h;
                if (ind3.includes('горизонтальные') || ind3.includes('верх')){
                    l =w;
                }

                kolvo =  (Math.ceil(((l -40)/ 320 +  1)) * k).toFixed(3);


                /* if (h < 1500) {
                     kolvo = (4 * k).toFixed(3);
                 } else {
                     kolvo = (6 * k).toFixed(3);
                 }*/
            }
            if (
                name.includes('гвоздь мс плиссе 16мм') ||
                name.includes('заглушка')
            ) {
                kolvo = (4).toFixed(3);
            }
            if (name.includes('пятка')) {
                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    kolvo = (4).toFixed(3);
                } else {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('угол стандарт')) {
                if (porog === 'Низкий') {
                    kolvo = (2).toFixed(3);
                } else {
                    kolvo = (4).toFixed(3);
                }
            }
            if (name.includes('угол порог система п16')) {
                if (porog === 'Низкий') {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('работа')) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('уплотнитель') && name.includes(uplot.toLowerCase()))
            {
                if( ind3 === 'Створки от краев к середине горизонтальные')
                {
                    kolvo = ((w) / 1000).toFixed(3);
                }
                else
                {
                    kolvo = ((h) / 1000).toFixed(3);
                }
            }





            if (name.includes('промежуточный ')) {
                if (
                    ind3 === 'Створка от краев к середине'
                ) {
                    kolvo = ((h * 2) / 1000).toFixed(3);
                } else  if (

                    ind3 === 'Створки от краев к середине горизонтальные'
                ) {
                    kolvo = ((w * 2) / 1000).toFixed(3);
                } else if (
                    ind3 === 'Створка от середины к краям'
                ) {
                    kolvo = 0;
                } else {
                    kolvo = ((h) / 1000).toFixed(3);
                }
            }
            if (name.includes('вставка') || name.includes('скотч')) {
                let d;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        d = w;
                        break;

                    default:
                        d = h;
                        break;
                }

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 69 + w - 30) / 1000).toFixed(3);
                        break;

                    case 'Створки от краев к середине горизонтальные':
                        kolvo = 0;
                        break;

                    default:
                        switch (porog) {
                            case 'Низкий': {
                                if (ind3 === 'Створка от середины к краям' ) {
                                    kolvo = ((h - 60 + h - 60) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 60 + h - 20) / 1000).toFixed(3);
                                }
                                break;
                            }
                            case 'Рамный': {
                                if (ind3 === 'Створка от середины к краям') {
                                    kolvo = ((h - 69 + h - 69) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 69 + h - 30) / 1000).toFixed(3);
                                }
                                break;
                            }
                        }

                        if (ind3.includes('от краев к середине')) {
                            if (name.includes('метал')) {
                                kolvo = 0;
                            } else {
                                kolvo = (kolvo * 2).toFixed(3);
                            }
                        }
                        break;
                }
            }


            if ( falsrama=='Да' && name.includes('фальш-рама')  ) {
                kolvo = ((2 * h + w) / 1000).toFixed(3);
            }

            if (kolvo) {


                const isTkanMat = SHTORKA_TYPES.some(({keyword}) => keyword.some(kw => name.includes(kw)));



                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price* (isTkanMat ? nacenkaTkanRozn : 1));
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price* (isTkanMat ? nacenkaTkanOpt : 1));
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost* (isTkanMat ? nacenkaTkanSebest : 1));

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        }, 250);

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000});
        dispatch('item', result);
    });

    change();


    $: recomendWidth =
        ind3 === 'Створка от краев к середине'
            ? 3000
            : (options.recomend && options.recomend.width ? options.recomend.width : 1600);

</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center  text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2}
                                        on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Ширина, мм ≥ { recomendWidth }</label>
                                <input type="number"
                                       class="form-control text-center { $width > recomendWidth ? 'text-danger' : '' }"
                                       step="10" min="300"
                                       max="{ options.max && options.max.width ? options.max.width : 3000 }"
                                       bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Высота, мм
                                    ≥ { options.recomend && options.recomend.height ? options.recomend.height : 2500 }</label>
                                <input type="number"
                                       class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 2500) ? 'text-danger' : '' }"
                                       step="10" min="300"
                                       max="{ options.max && options.max.height ? options.max.height : 2500 }"
                                       bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип полотна</label>
                                <select class="form-control form-select" bind:value={type} on:change={change}>
                                    {#each types as value}
                                        {#if value !== 'Сетка/Ткань' || ind3 === 'Створка от краев к середине'}
                                            <option value="{value}">{value}</option>
                                        {/if}
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Уплотнитель</label>
                                <select class="form-control form-select" bind:value={uplot}>
                                    <option value="Без уплотнения">Без уплотнения</option>
                                    <option value="Щеточный">Щеточный</option>
                                    <option value="Магнитный">Магнитный</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {#if type !== 'Ткань'}
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип сетки</label>
                                    <select class="form-control form-select" bind:value={$webtype} on:change={change}>
                                        <option value="" disabled selected>— Выберите тип —</option>
                                        {#each webtypes as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if type !== 'Сетка'}
                        <div class="shtorType">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Вид шторы</label>
                                    <select class="form-control form-select" bind:value={vidShtor}
                                            on:change={() => cvetShtor = shtorkaColors(vidShtor, data.result)[0]}>
                                        {#each availableShtorTypes(data.result) as {type}}
                                            <option value="{type}">{type}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="shtorColor">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет шторы</label>
                                    <select class="form-control form-select" bind:value={cvetShtor}>
                                        {#each shtorkaColors(vidShtor, data.result) as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Фальш-рама</label>
                                <select class="form-control form-select" bind:value={falsrama} on:change={change}>
                                    <option value="Да">Да</option>
                                    <option value="Нет">Нет</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3"
                     src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">

            {#if APP_TYPE === 'moskitoscompany' || APP_TYPE === 'axis-one'}
                <div class="col-6">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Порог</label>
                            <select class="form-control form-select" bind:value={porog}>
                                <option value="Рамный">Рамный</option>
                                <option value="Низкий">Низкий</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
